'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationShoppingTabsPassengerController = function () {
    function WinresReservationShoppingTabsPassengerController($scope) {
        _classCallCheck(this, WinresReservationShoppingTabsPassengerController);

        this.$scope = $scope;
    }

    _createClass(WinresReservationShoppingTabsPassengerController, [{
        key: '$onInit',
        value: function $onInit() {

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().NumAdults

            this.data = this.winresReservationContext.getContext();
            this.limit = this.data.NumAdults * 50; // just a enough big number to show enough all passengers
            if (this.pplLimit != null) {
                this.limit = this.pplLimit;
            }
        }
    }, {
        key: 'click',
        value: function click() {
            this.winresReservationShoppingTabs.goToPhase('passenger');

            // Google analytics.
            // Send event when click edit passengers.
            this.winresReservationContext.analyticsEvent("trackCart");
        }
    }]);

    return WinresReservationShoppingTabsPassengerController;
}();

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'shopping-tabs-passenger';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('shopping-tabs-passenger', require('./winresReservationShoppingTabsPassenger.html'));
}]);

WinresReservationShoppingTabsPassengerController.$inject = ['$scope'];

_module3.default.component('winresReservationShoppingTabsPassenger', {
    templateUrl: getTemplate,
    controller: WinresReservationShoppingTabsPassengerController,
    require: {
        winresReservationContext: '^^winresReservationContext',
        winresReservationShoppingTabs: '^^winresReservationShoppingTabs'
    },
    bindings: {
        language: '@',
        pplLimit: '@',
        modifyButton: '@', //default: false
        participantMode: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationShoppingTabsPassenger/winresReservationShoppingTabsPassenger.js
// module id = 399
// module chunks = 2